export const recordBoundedIdentifier = (
  identifiers: Set<string>,
  identifier: string,
  maximum: number,
): void => {
  identifiers.delete(identifier);
  identifiers.add(identifier);
  const overflow = identifiers.size - maximum;
  let removed = 0;
  for (const oldest of identifiers) {
    if (removed >= overflow) {
      break;
    }
    identifiers.delete(oldest);
    removed += 1;
  }
};

export const retainNewest = <Value>(
  values: readonly Value[],
  maximum: number,
): readonly Value[] => values.slice(-maximum);
